"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteKnowledge = void 0;
var DeletedApiKeyImpulse_1 = require("./DeletedApiKeyImpulse");
var DeletedFulfilmentImpulse_1 = require("./DeletedFulfilmentImpulse");
var DeletedBehaviourImpulse_1 = require("./DeletedBehaviourImpulse");
var DeletedTenantImpulse_1 = require("./DeletedTenantImpulse");
var DeletedSkillProvisionImpulse_1 = require("./DeletedSkillProvisionImpulse");
var DeletedStatementImpulse_1 = require("./DeletedStatementImpulse");
var DeletedSkillImpulse_1 = require("./DeletedSkillImpulse");
var DeletedRoleImpulse_1 = require("./DeletedRoleImpulse");
var DeletedCodeImpulse_1 = require("./DeletedCodeImpulse");
var DeletedEdgeImpulse_1 = require("./DeletedEdgeImpulse");
var DeletedIdentityImpulse_1 = require("./DeletedIdentityImpulse");
var DeletedIntentImpulse_1 = require("./DeletedIntentImpulse");
var DeletedPromptImpulse_1 = require("./DeletedPromptImpulse");
var DeletedUserImpulse_1 = require("./DeletedUserImpulse");
var DeleteKnowledge = /** @class */ (function (_super) {
    __extends(DeleteKnowledge, _super);
    function DeleteKnowledge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "DeleteKnowledge";
        /**
         * deletes a list of identities with the given specifications
         */
        _this.identities = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedIdentityImpulse_1.DeletedIdentityImpulse();
            config(entity);
            return "identities(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of tenants with the given specifications
         */
        _this.tenants = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedTenantImpulse_1.DeletedTenantImpulse();
            config(entity);
            return "tenants(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of users with the given specifications
         */
        _this.users = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedUserImpulse_1.DeletedUserImpulse();
            config(entity);
            return "users(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of api keys with the given specifications
         */
        _this.apiKeys = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedApiKeyImpulse_1.DeletedApiKeyImpulse();
            config(entity);
            return "apiKeys(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of roles with the given specifications
         */
        _this.roles = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedRoleImpulse_1.DeletedRoleImpulse();
            config(entity);
            return "roles(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of intents with the given specifications
         */
        _this.intents = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedIntentImpulse_1.DeletedIntentImpulse();
            config(entity);
            return "intents(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of prompts with the given specifications
         */
        _this.prompts = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedPromptImpulse_1.DeletedPromptImpulse();
            config(entity);
            return "prompts(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of statements with the given specifications
         */
        _this.statements = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedStatementImpulse_1.DeletedStatementImpulse();
            config(entity);
            return "statements(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of fulfilments with the given specifications
         */
        _this.fulfilments = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedFulfilmentImpulse_1.DeletedFulfilmentImpulse();
            config(entity);
            return "fulfilments(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of behaviours with the given specifications
         */
        _this.behaviours = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedBehaviourImpulse_1.DeletedBehaviourImpulse();
            config(entity);
            return "behaviours(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of codes with the given specifications
         */
        _this.codes = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedCodeImpulse_1.DeletedCodeImpulse();
            config(entity);
            return "codes(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of edges with the given specifications
         */
        _this.edges = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedEdgeImpulse_1.DeletedEdgeImpulse();
            config(entity);
            return "edges(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of skills with the given specifications
         */
        _this.skills = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedSkillImpulse_1.DeletedSkillImpulse();
            config(entity);
            return "skills(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * deletes a list of skill provisions with the given specifications
         */
        _this.skillProvisions = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new DeletedSkillProvisionImpulse_1.DeletedSkillProvisionImpulse();
            config(entity);
            return "skillProvisions(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return DeleteKnowledge;
}(Array));
exports.DeleteKnowledge = DeleteKnowledge;
//# sourceMappingURL=DeleteKnowledge.js.map